<div *ngIf="loading">
  <mat-spinner color="primary" diameter="30"></mat-spinner>
</div>

<div class="sub-project-grid">
  <div
    *ngFor="let item of completedSubProjectItems; trackBy: trackById"
    class="sub-project-grid-item"
  >
    <client-corner-home-page-completed-subproject-item
      [subProject]="item"
    ></client-corner-home-page-completed-subproject-item>
  </div>
</div>
